// latest: zhangmyh 2017-4-11 8:56 PM
import { Model } from 'common'
import './evaObj'
import './evaOrg'
import './evaSupplier'
import './evaExtra'
import '../evalIndicator/evalIndicator'

let urls = {
  detail: {
    get: '/cpu-supplymgr/evaluateApply/getById',
    post: '/cpu-supplymgr/evaluateApply/save'
  },
  report: {
    get: '/cpu-supplymgr/evaluateReport/getReportByApplyId'
  },
  scheme: {
    get: '/cpu-supplymgr/evaluateScheme/getById',
    post: '/cpu-supplymgr/evaluateScheme/save'
  }
}

let associations = {
  detail: {
    evaObjectList: {
      type: 'hasMany', // hasMany
      model: 'evalapply.evaobj'
    },
    evaOrgList: {
      type: 'hasMany',
      model: 'evalapply.evaorg'
    },
    evaIndicatorList: {
      type: 'hasMany',
      model: 'evalapply.indicator'
    },
    evaExtraList: {
      type: 'hasMany',
      model: 'evalapply.extra'
    }
  },
  report: {
    repSupplyList: {
      type: 'hasMany',
      model: 'evalapply.supplier'
    }
  },
  scheme: {
    orgList: {
      type: 'hasMany',
      model: 'evalapply.evaorg'
    },
    indicatorList: {
      type: 'hasMany',
      model: 'evalapply.indicator'
    },
    extraList: {
      type: 'hasMany',
      model: 'evalapply.extra'
    }
  }
}

const applyBasicMeta = {
  applyCode: { type: 'string', required: true, nullMsg: '请添加编号' },
  applyTitle: { type: 'string', required: true, nullMsg: '请添加标题' },
  evaStartDate: {
    type: 'date',
    required: true,
    nullMsg: '请选择开始时间'
    /* check: function (data, field, obj) {
      let status = 1
      let msg = ''
      if (data) {
        let now = new Date()
        if (data < now.getTime()) {
          status = 0
          msg = '开始时间早于当前时间'
        }
      }
      return { status, msg }
    } */
  },
  evaEndDate: { type: 'date', required: true, nullMsg: '请选择结束时间' },
  applyOrgId: '',
  applyOrgName: '',
  scoredSchedule: ''
}

const basicMeta = {
  id: { type: 'integer' },
  evaWeightType: { type: 'string', required: true, nullMsg: '请添加权重' },
  summaryRule: { type: 'string', required: true, nullMsg: '请添加汇总规则' },
  evaAbilityId: { type: 'integer', required: true, nullMsg: '请选择等级体系' },
  evaAbilityName: '',
  evaStandard: '',
  applyDate: { type: 'date' },
  evaType: '',
  memo: ''
}

export default function (model) {
  let name = `evalapply.${model}`
  let meta
  switch (model) {
    case 'detail':
      meta = Object.assign({}, basicMeta, applyBasicMeta)
      break
    case 'report':
      meta = Object.assign({
        applyPsnId: '',
        applyPsnName: '',
      }, basicMeta, applyBasicMeta)
      break
    case 'scheme':
      meta = Object.assign({
        schemeCode: { type: 'string', required: true, nullMsg: '请添加编号' },
        schemeName: { type: 'string', required: true, nullMsg: '请添加名称' }
      }, basicMeta)
      break
  }
  Model.define(name, {
    proxy: urls[model],
    meta,
    associations: associations[model]
  })
  return Model.create(name)
}



// WEBPACK FOOTER //
// ./src/data/model/evaluationApply/index.js